import { render, staticRenderFns } from "./Decision.vue?vue&type=template&id=ecb0a3ec&scoped=true"
import script from "./Decision.vue?vue&type=script&lang=js"
export * from "./Decision.vue?vue&type=script&lang=js"
import style0 from "./Decision.vue?vue&type=style&index=0&id=ecb0a3ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb0a3ec",
  null
  
)

export default component.exports